import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getDashboardConfiguration,
  saveDashboardConfiguration
} from "./../../modules/dashboard";
import "./Dashboard.css";
import { Grid } from "material-ui";
import { Typography } from "material-ui";
import { TextField } from "material-ui";
import { Dialog, AppBar, Toolbar } from "material-ui";
import { DialogActions } from "material-ui";
import { DialogTitle } from "material-ui";
import { DialogContent } from "material-ui";
import { Button } from "material-ui";
import { Slide } from "material-ui";
import IconButton from "material-ui/IconButton";
import CloseIcon from "material-ui-icons/Close";
import { FormControlLabel } from "material-ui";
import { Switch } from "material-ui";
import { Radio } from "material-ui";
import { RadioGroup } from "material-ui";
import { FormControl } from "material-ui";
import { List, ListItem } from "material-ui";
import { Checkbox } from "material-ui";
import { ListItemText } from "material-ui";
import LeftArrowIcon from "material-ui-icons/KeyboardArrowLeft";
import RightArrowIcon from "material-ui-icons/KeyboardArrowRight";
import {
  IGNITION_STATUS_TILE,
  IGNITION_STATUS_CHART_TILE,
  MOVING_UNITS_CHART_TILE,
  MOVING_UNITS_TILE,
  UNITS_STATUS_CHART_TILE,
  UNITS_STATUS_TILE
} from "./DashboardView";

class DashboardConfiguration extends Component {
  constructor(props) {
    super(props);
    if (this.props.configuration) {
      const { configuration, selectedUnits, notSelectedUnits } = this.props;
      this.state = {
        fuelPrice: configuration.PrecioCombustible.toString(),
        updateInterval: configuration.IntervaloActualizacion.toString(),
        requestRange: configuration.RangoConsulta.toString(),
        selectedUnits: selectedUnits,
        notSelectedUnits: notSelectedUnits,
        checkedSelected: [],
        checkedNotSelected: [],
        selectedAll: false,
        notSelectedAll: false,
        tiles: configuration.Tarjetas
      };
    } else {
      this.state = {
        fuelPrice: 0,
        updateInterval: "0",
        requestRange: "12",
        selectedUnits: [],
        notSelectedUnits: [],
        checkedSelected: [],
        checkedNotSelected: [],
        selectedAll: false,
        notSelectedAll: false,
        tiles: []
      };
    }
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.fuelPrice !== prevProps.fuelPrice)
      this.setState({ fuelPrice: this.props.fuelPrice });

    if (this.props.selectedUnits !== prevProps.selectedUnits) {
      const { selectedUnits } = this.props;
      this.setState({ selectedUnits });
    }

    if (this.props.notSelectedUnits !== prevProps.notSelectedUnits) {
      const { notSelectedUnits } = this.props;
      this.setState({ notSelectedUnits });
    }

    if (this.props.configuration !== prevProps.configuration) {
      const {
        PrecioCombustible,
        RangoConsulta,
        IntervaloActualizacion,
        Tarjetas
      } = this.props.configuration;

      this.setState({
        fuelPrice: PrecioCombustible.toString(),
        updateInterval: IntervaloActualizacion.toString(),
        requestRange: RangoConsulta.toString(),
        tiles: Tarjetas
      });
    }
  };

  handleFuelPrice = e => {
    const value = e.target.value;
    this.setState({ fuelPrice: value !== "" ? parseFloat(value) : 0 });
  };

  handleOnChangeSwitch = e => {
    const { name, checked } = e.target;
    let tiles = this.state.tiles;
    let index = -1;

    if (checked) {
      switch (name) {
        case "ignitionStatusType":
          index = tiles.indexOf(IGNITION_STATUS_TILE);
          if (index >= 0) tiles[index] = IGNITION_STATUS_CHART_TILE;
          break;
        case "movingUnitsType":
          index = tiles.indexOf(MOVING_UNITS_TILE);
          if (index >= 0) tiles[index] = MOVING_UNITS_CHART_TILE;
          break;
        case "unitsStatusType":
          index = tiles.indexOf(UNITS_STATUS_TILE);
          if (index >= 0) tiles[index] = UNITS_STATUS_CHART_TILE;
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case "ignitionStatusType":
          index = tiles.indexOf(IGNITION_STATUS_CHART_TILE);
          if (index >= 0) tiles[index] = IGNITION_STATUS_TILE;
          break;
        case "movingUnitsType":
          index = tiles.indexOf(MOVING_UNITS_CHART_TILE);
          if (index >= 0) tiles[index] = MOVING_UNITS_TILE;
          break;
        case "unitsStatusType":
          index = tiles.indexOf(UNITS_STATUS_CHART_TILE);
          if (index >= 0) tiles[index] = UNITS_STATUS_TILE;
          break;
        default:
          break;
      }
    }

    this.setState({ tiles });
  };

  handleUpdateIntervalRadio = e => {
    const { value, name } = e.target;
    this.setState({ updateInterval: value });
  };

  handleRequestRangeRadio = e => {
    const { value } = e.target;
    this.setState({ requestRange: value });
  };

  handleSelectUnits = () => {
    let { selectedUnits, notSelectedUnits, checkedNotSelected } = this.state;

    selectedUnits = selectedUnits.concat(checkedNotSelected);

    notSelectedUnits = selectedUnits.reduce((acum, val) => {
      return acum.filter(u => u.Unidad !== val.Unidad);
    }, notSelectedUnits);

    this.setState({
      selectedUnits,
      notSelectedUnits,
      checkedNotSelected: [],
      checkedSelected: [],
      selectedAll: false,
      notSelectedAll: false
    });
  };

  handleUnselectUnits = () => {
    let {
      selectedUnits,
      notSelectedUnits,

      checkedSelected
    } = this.state;

    notSelectedUnits = notSelectedUnits.concat(checkedSelected);

    selectedUnits = notSelectedUnits.reduce((acum, val) => {
      return acum.filter(u => u.Unidad !== val.Unidad);
    }, selectedUnits);

    this.setState({
      selectedUnits,
      notSelectedUnits,
      checkedNotSelected: [],
      checkedSelected: [],
      selectedAll: false,
      notSelectedAll: false
    });
  };

  handleCheckNotSelected = e => {
    const { value, name, checked } = e.target;
    let { checkedNotSelected, notSelectedUnits, notSelectedAll } = this.state;

    if (name === "notSelectedAll") {
      if (checked) {
        this.setState({
          checkedNotSelected: notSelectedUnits,
          notSelectedAll: !notSelectedAll
        });
      } else {
        this.setState({
          checkedNotSelected: [],
          notSelectedAll: !notSelectedAll
        });
      }
      return;
    }

    if (checked) {
      checkedNotSelected.push(
        this.state.notSelectedUnits.filter(u => u.Unidad === name)[0]
      );
      this.setState({
        checkedNotSelected,
        notSelectedAll: false
      });
    } else {
      checkedNotSelected = checkedNotSelected.filter(u => u.Unidad !== name);
      this.setState({ checkedNotSelected, notSelectedAll: false });
    }
  };

  handleCheckSelected = e => {
    const { value, name, checked } = e.target;
    let { checkedSelected, selectedUnits, selectedAll } = this.state;

    if (name === "selectedAll") {
      if (checked) {
        this.setState({
          checkedSelected: selectedUnits,
          selectedAll: !selectedAll
        });
      } else {
        this.setState({
          checkedSelected: [],
          selectedAll: !selectedAll
        });
      }
      return;
    }

    if (checked) {
      checkedSelected.push(
        this.state.selectedUnits.filter(u => u.Unidad === name)[0]
      );
      this.setState({
        checkedSelected,
        selectedAll: false
      });
    } else {
      checkedSelected = checkedSelected.filter(u => u.Unidad !== name);
      this.setState({ checkedSelected, selectedAll: false });
    }
  };

  saveConfiguration = e => {
    const {
      fuelPrice,
      tiles,
      updateInterval,
      requestRange,
      selectedUnits
    } = this.state;
    const configuration = {
      Unidades: selectedUnits.map(u => u.Unidad),
      Tarjetas: tiles,
      IntervaloActualizacion: updateInterval,
      RangoConsulta: requestRange,
      PrecioCombustible: fuelPrice
    };
    this.props.saveDashboardConfiguration({ configuracion: configuration });
    this.props.onCloseConfiguration();
  };

  render() {
    const {
      data,
      isConfigurationOpen,
      onCloseConfiguration,
      lang
    } = this.props;
    return (
      <Dialog
        className="dashboard"
        open={isConfigurationOpen}
        transition={Transition}
        fullScreen
      >
        <DialogTitle>
          <AppBar>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={onCloseConfiguration}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className="flex">
                {lang.Ajustes}
              </Typography>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent>
          <div className="dashboard-configuration">
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="  ">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.EstadoDeIgnicion}
                  </Typography>

                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="subheading"
                    color="textSecondary"
                  >
                    {lang.Valor}
                    <Switch
                      name="ignitionStatusType"
                      onChange={this.handleOnChangeSwitch}
                      checked={
                        this.state.tiles.filter(
                          t => t === IGNITION_STATUS_CHART_TILE
                        ).length > 0
                      }
                    />
                    {lang.Grafica}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.CombustibleCalculado}
                  </Typography>

                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="subheading"
                    color="textSecondary"
                    align="left"
                  >
                    {lang.Precio}
                  </Typography>
                  <Typography
                    variant="title"
                    color="textSecondary"
                    align="left"
                  >
                    <TextField
                      type="number"
                      onChange={this.handleFuelPrice}
                      value={this.state.fuelPrice}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className=" ">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.EstadoDeMovimiento}
                  </Typography>

                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="subheading"
                    color="textSecondary"
                  >
                    {lang.Valor}
                    <Switch
                      name="movingUnitsType"
                      onChange={this.handleOnChangeSwitch}
                      checked={
                        this.state.tiles.filter(
                          t => t === MOVING_UNITS_CHART_TILE
                        ).length > 0
                      }
                    />
                    {lang.Grafica}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className=" ">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.IntervaloDeActualizacion}
                  </Typography>

                  <FormControl component="fieldset">
                    <RadioGroup
                      onChange={this.handleUpdateIntervalRadio}
                      value={this.state.updateInterval.toString()}
                    >
                      {/* <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="1 Minuto"
                      /> */}

                      <FormControlLabel
                        value="5"
                        control={<Radio />}
                        label={`5 ${lang.Minutos}`}
                      />

                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Manual"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl component="fieldset">
                    <RadioGroup
                      onChange={this.handleUpdateIntervalRadio}
                      value={this.state.updateInterval}
                    >
                      <FormControlLabel
                        value="10"
                        control={<Radio />}
                        label={`10 ${lang.Minutos}`}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className=" ">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.EstadoDeConectividad}
                  </Typography>

                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="subheading"
                    color="textSecondary"
                  >
                    {lang.Valor}
                    <Switch
                      name="unitsStatusType"
                      onChange={this.handleOnChangeSwitch}
                      checked={
                        this.state.tiles.filter(
                          t => t === UNITS_STATUS_CHART_TILE
                        ).length > 0
                      }
                    />
                    {lang.Grafica}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className=" ">
                  <Typography
                    style={{ marginTop: "1rem" }}
                    variant="title"
                    color="primary"
                  >
                    {lang.RangoDeConsulta}
                  </Typography>

                  <FormControl component="fieldset">
                    <RadioGroup
                      onChange={this.handleRequestRangeRadio}
                      value={this.state.requestRange}
                    >
                      <FormControlLabel
                        value="8"
                        control={<Radio />}
                        label="8 horas"
                      />

                      <FormControlLabel
                        value="12"
                        control={<Radio />}
                        label="12 horas"
                      />

                      <FormControlLabel
                        value="24"
                        control={<Radio />}
                        label="24 horas"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  variant="title"
                  color="primary"
                  align="center"
                  style={{ marginTop: "1rem" }}
                >
                  {lang.Unidades}
                </Typography>
                <Grid container>
                  <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                    <Typography
                      variant="subheading"
                      color="primary"
                      align="center"
                      style={{ marginTop: "1rem" }}
                    >
                      <Checkbox
                        style={{ float: "left" }}
                        name={"notSelectedAll"}
                        onChange={this.handleCheckNotSelected}
                        checked={this.state.notSelectedAll}
                      />
                      {lang.NoSeleccionadas}
                    </Typography>
                    <div className="units-list">
                      {this.state.notSelectedUnits.map(u => (
                        <ListItem dense button key={u.Unidad}>
                          <Checkbox
                            name={u.Unidad}
                            onChange={this.handleCheckNotSelected}
                            checked={
                              this.state.checkedNotSelected.filter(
                                ch => ch.Unidad === u.Unidad
                              ).length > 0
                            }
                          />
                          <ListItemText primary={u.Descripcion} />
                        </ListItem>
                      ))}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                    <Typography
                      style={{ marginTop: "8rem" }}
                      variant="title"
                      color="primary"
                      align="center"
                    >
                      <IconButton onClick={this.handleUnselectUnits}>
                        <LeftArrowIcon />
                      </IconButton>
                      <IconButton onClick={this.handleSelectUnits}>
                        <RightArrowIcon />
                      </IconButton>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                    <Typography
                      variant="subheading"
                      color="primary"
                      align="center"
                      style={{ marginTop: "1rem" }}
                    >
                      <Checkbox
                        style={{ float: "left" }}
                        name={"selectedAll"}
                        onChange={this.handleCheckSelected}
                        checked={this.state.selectedAll}
                      />
                      {lang.Seleccionadas}
                    </Typography>
                    <div className="units-list">
                      <List>
                        {this.state.selectedUnits.map(
                          u =>
                            u !== undefined ? (
                              <ListItem dense button key={u.Unidad}>
                                <Checkbox
                                  name={u.Unidad}
                                  onChange={this.handleCheckSelected}
                                  checked={
                                    this.state.checkedSelected.filter(
                                      ch => ch.Unidad === u.Unidad
                                    ).length > 0
                                  }
                                />
                                <ListItemText primary={u.Descripcion} />
                              </ListItem>
                            ) : null
                        )}
                      </List>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="raised"
            onClick={this.saveConfiguration}
          >
            {lang.Guardar}
          </Button>
          <Button
            color="primary"
            variant="raised"
            onClick={this.defaultConfiguration}
          >
            {lang.ValoresPorDefecto}
          </Button>
          <Button
            color="primary"
            variant="raised"
            onClick={this.resetConfiguration}
          >
            {lang.Restablecer}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const mapStateToProps = state => {
  const notSelectedUnits = state.dashboard.configuration.Unidades.reduce(
    (acum, val) => {
      return acum.filter(u => u.Unidad !== val);
    },
    state.units.data
  );

  const selectedUnits = state.dashboard.configuration.Unidades.map(u => {
    return state.units.data.filter(unit => unit.Unidad === u)[0];
  });

  return {
    configuration: state.dashboard.configuration,
    selectedUnits,
    notSelectedUnits
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { getDashboardConfiguration, saveDashboardConfiguration },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardConfiguration);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardConfiguration.js